import React, { useEffect, useState } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useApiHook } from '../Helper/ApiHook/apiHook';
import axios from "axios";
import './Dashboard.css';


function DoseSpot({ selectedCase,refresh}) {
    const { caseType } = useParams()
    const { token } = useParams();
    const { caseid } = useParams();
    const { refillid } = useParams();
    const { doseSpotidParam } = useParams();
    const { pharmacyidParam } = useParams();
    const { clinicianidParam } = useParams();

    const navigate = useNavigate();
    const [{ user }, dispatch] = useStateValue();
    const [patient, setPatient] = useState(null);
    const [pharmacy, setPharmacy] = useState(null);
    const [prescriber, setPrescriber] = useState(null);
    const [prescriptions, setPrescriptions] = useState([]);
    const [doseSpotid, setDoseSpotid] = useState(null);
    const [pharmacyid, setPharmacyid] = useState(null);
    const [clinicianid, setClinicianid] = useState(null);

    useEffect(() => {
        if (typeof selectedCase !== 'undefined') {
          
            setDoseSpotid(selectedCase.dose_spot_patient_id);
            setPharmacyid(selectedCase.pharmacy_id);
            setClinicianid(selectedCase.dose_spot_user_id);
        }
        else {
            setDoseSpotid(doseSpotidParam);
            setPharmacyid(pharmacyidParam);
            setClinicianid(clinicianidParam);
        
        
        }
    }, [selectedCase])

    useEffect(() => {
        if (doseSpotid !== null && pharmacyid !== null && clinicianid !== null)
          //  GetPrescriptionFavorites();
            callDoseSpot()
    }, [doseSpotid, pharmacyid, clinicianid])

    

    //const GetPrescriptionFavorites = () => {
    //    const url = 'api/doseSpot/GetPrescriptionFavorites';

    //    const params = {

    //        "DoseSpotID": doseSpotid,
    //        "PharmacyID": pharmacyid,
    //        "ClinicianID": clinicianid
    //    }

    //    var endpoint = location.origin + '/' + url;
    //    axios.post(endpoint, params)

    //        .then(function (response) {
    //            //handle success
    //            if (response.status === 200) {
    //                var data = JSON.parse(response.data.PrescriptionFavorites);
                   
    //                console.log(data);
                   
                   
    //            }

    //        })
    //        .catch(function (response) {
    //            //handle error
    //            alert(response);
    //            console.log(response);
    //        });
    //}

    const callDoseSpot = () => {
        const url = 'api/doseSpot/DoseSpotAPI';

        const params = {

            "DoseSpotID": doseSpotid,
            "PharmacyID": pharmacyid,
            "ClinicianID": clinicianid
        }

        var endpoint = location.origin + '/' + url;
        axios.post(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.status === 200) {
                    var patient = JSON.parse(response.data.Patient);
                    var pharmacy = JSON.parse(response.data.Pharmacy);
                    var clinician = JSON.parse(response.data.Clinician);
                    var prescriptions = JSON.parse(response.data.Prescriptions);
                    // console.log(patient);
                    // console.log(pharmacy);
                    // console.log(prescriptions);
                   // console.log(clinician);
                    setPatient(patient.Item);
                    setPharmacy(pharmacy.Item)
                    setPrescriber(clinician.Item)
                    setPrescriptions(prescriptions.Items)
                }

            })
            .catch(function (error) {
                //handle error
                alert(error);
                
            });
    }


    return (
        <div className="dashboard tab" >

            <div className="mt-0">
              
                {

                    selectedCase &&
                    <div className="display-6">
                            {selectedCase.first_name && <span className="fs-2"> {selectedCase.first_name} {selectedCase.middle_initial} {selectedCase.last_name} - {selectedCase.pharmacy_state}  </span>}
                            <span className="ml-3 fs-4">Token:{selectedCase.token} {selectedCase.casetype === 'Case' ? 'Case:' + selectedCase.id : 'Refill:' + selectedCase.refillID} Status: {selectedCase.status}</span>
                    </div>
                }
                <hr/>
                <div className="row">
                    {/* Patient Info */}
                    <div className="col-md-4">
                        <div className="card shadow-lg">
                            <div className="card-header bg-primary text-white">Patient Info</div>
                            <div className="card-body">
                                {patient ? (
                                    <>
                                        <h5>{patient.FirstName} {patient.MiddleName} {patient.LastName}</h5>
                                        <div><strong>DOB:</strong> {patient.DateOfBirth}</div>
                                        <div><strong>Gender:</strong> {patient.Gender}</div>
                                        <div><strong>Phone:</strong> {patient.PrimaryPhone}</div>
                                        <div><strong>Address:</strong> {patient.Address1} {patient.Address2} <br />{patient.City} {patient.State} {patient.ZipCode}</div>
                                    </>
                                ) : (
                                    <p>Loading patient info...</p>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Pharmacy Info */}
                    <div className="col-md-4">
                        <div className="card shadow-lg">
                            <div className="card-header bg-success text-white">Pharmacy Info</div>
                            <div className="card-body">
                                {pharmacy ? (
                                    <>
                                        <h5>{pharmacy.StoreName}</h5>
                                        <div><strong>PharmacyId:</strong> {pharmacy.PharmacyId}</div>
                                        <div><strong>Phone:</strong> {pharmacy.PrimaryPhone}</div>
                                        <div><strong>Address:</strong> {pharmacy.Address1} {pharmacy.Address2}  <br />{pharmacy.City} {pharmacy.State} {pharmacy.ZipCode}</div>


                                    </>
                                ) : (
                                    <p>Loading pharmacy info...</p>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Prescriber Info */}
                    <div className="col-md-4">
                        <div className="card shadow-lg">
                            <div className="card-header bg-warning text-white">Prescriber Info</div>
                            <div className="card-body">
                                {prescriber ? (
                                    <>
                                        <h5>{prescriber.FirstName} {prescriber.LastName}</h5>
                                        <div><strong>ClinicianId:</strong> {prescriber.ClinicianId}</div>
                                        <div><strong>Email:</strong> {prescriber.Email}</div>
                                        <div><strong>State:</strong> {prescriber.State} </div>


                                    </>
                                ) : (
                                    <p>Loading pharmacy info...</p>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Prescription Info */}
                    <div className="col-md-12 mt-4">
                        <div className="card shadow-lg">
                            <div className="card-header bg-info text-white">Prescription Info</div>
                            <div className="card-body">
                                {prescriptions.length > 0 ? (
                                    <table className="table table-striped">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>Written Date</th>
                                                <th>Status</th>
                                                <th>Medication</th>
                                                <th>Strength</th>
                                                <th>Quantity</th>
                                                <th>Refills</th>
                                                <th>Directions</th>
                                                <th>Notes</th>
                                                <th>Comments</th>
                                                <th>PrescriberId</th>
                                                <th>PharmacyId</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {prescriptions && prescriptions.map((prescription) => (
                                                <tr key={prescription.PrescriptionId}>

                                                    <td>{prescription.WrittenDate}</td>
                                                    <td>{prescription.Status}</td>
                                                    <td>{prescription.DisplayName}</td>
                                                    <td>{prescription.Strength}</td>

                                                    <td>{prescription.Quantity}</td>
                                                    <td>{prescription.Refills}</td>
                                                    <td>{prescription.Directions}</td>
                                                    <td>{prescription.PharmacyNotes}</td>
                                                    <td>{prescription.Comment}</td>
                                                    <td>{prescription.PrescriberId}</td>
                                                    <td>{prescription.PharmacyId}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p>No prescriptions found.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>





        </div>

    );

}
export default DoseSpot;

